
import React from "react";

interface BeginnerTierDataProps {
  tierData: any;
}

export default function BeginnerTierData({ tierData }: BeginnerTierDataProps) {
  if (!tierData) return <p className="text-white/70">No tier data available</p>;
  
  // Helper function to format equipment preference for display
  const formatEquipmentPreference = (preference: string) => {
    switch (preference) {
      case "bodyweight_only": return "Bodyweight Only";
      case "freeweights": return "Freeweights";
      case "mixture": return "Mixture (Bodyweight and Weights)";
      default: return preference;
    }
  };
  
  return (
    <div className="space-y-3">
      <div className="flex">
        <span className="text-white/80 w-40">First Program:</span>
        <span className="text-white">{tierData.firstProgram}</span>
      </div>
      {tierData.exerciseFamiliarity && (
        <div className="flex">
          <span className="text-white/80 w-40">Exercise Familiarity:</span>
          <span className="text-white">{tierData.exerciseFamiliarity.join(", ")}</span>
        </div>
      )}
      {tierData.equipmentPreference && (
        <div className="flex">
          <span className="text-white/80 w-40">Equipment Preference:</span>
          <span className="text-white">{formatEquipmentPreference(tierData.equipmentPreference)}</span>
        </div>
      )}
      {tierData.baselineMetrics && (
        <div className="flex">
          <span className="text-white/80 w-40">Baseline Metrics:</span>
          <span className="text-white">{tierData.baselineMetrics}</span>
        </div>
      )}
      {tierData.confidenceLevel && (
        <div className="flex">
          <span className="text-white/80 w-40">Confidence Level:</span>
          <span className="text-white">{tierData.confidenceLevel}</span>
        </div>
      )}
    </div>
  );
}
